const navbarHeight = "8rem";
export const subnavHeight = "4rem";

export const navbarComplementHeight = `calc(100vh - ${navbarHeight})`;
